module.exports = __webpack_public_path__ + "img/source3_11.1213e91d.png";